"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styleUtilities_1 = require("../../util/styleUtilities");
var shadows = {
    weak: (0, styleUtilities_1.createShadow)(0, 5, 20, 0.03),
    medium: (0, styleUtilities_1.createShadow)(0, 5, 10, 0.05),
    strong: (0, styleUtilities_1.createShadow)(0, 10, 20, 0.1),
    strongWithoutSpread: (0, styleUtilities_1.createShadow)(0, 10, 20, 0.1, false),
    insetTop: "inset ".concat((0, styleUtilities_1.createShadow)(0, 5, 10, 0.05)),
    insetBottom: "inset ".concat((0, styleUtilities_1.createShadow)(0, -5, 10, 0.05)),
};
exports.default = shadows;
